<template>
    <div class="project-detail-view">
        <div v-if="form.typ === 2 || (form.typ === 6 && selectedProject.isTyp2)" class="project-name-block">
            <div>
                <span class="project-type" v-if="form.pjcaT_SNO">{{ form.pjcaT_NAM }}</span>
                <span class="project-name" :class="{ 'clickable': isProjectOpenable }" @click="$emit('open', form.projectSNO)">{{ form.projectName }}</span>
            </div>
            <div class="project-name-actions">
                <el-button v-if="isProjectOpenable" size="mini" round  @click="$emit('open', form.projectSNO)">檢視專案</el-button>
            </div>
        </div>
        <div v-if="form.typ === 3 || (form.typ === 6 && !selectedProject.isTyp2)" class="project-name-block">
            <div>
                <span class="project-type">特定費用項目</span>
                <span class="project-name">{{ form.projectName }}</span>
            </div>
        </div>
        <div v-if="isProjectBudgetVisible" class="project-info-block" style="margin-top: 15px">
            <div class="project-budget-block">
                <div class="project-budget-usage-wrapper">
                    <div class="project-budget-usage-bar">
                        <div
                            v-if="otherPaidPercentage > 0"
                            class="other-paid-total-bar"
                            :style="{
                                'width': `${otherPaidChartPercentage}%`,
                                'left': `0%`,
                            }"
                        ></div>
                        <div
                            v-if="currPaymentPercentage > 0"
                            class="current-payment-total-bar"
                            :style="{
                                'width': `${currPaymentChartPercentage}%`,
                                'left': `${otherPaidChartPercentage}%`,
                            }"
                        ></div>
                        <div
                            v-if="otherUnpaidPercentage > 0"
                            class="other-unpaid-total-bar"
                            :style="{
                                'width': `${otherUnpaidChartPercentage}%`,
                                'left': `${otherPaidChartPercentage + currPaymentChartPercentage}%`,
                            }"
                        ></div>
                    </div>
                    <div
                        v-if="maxChartAmt > totalBudgetAmt"
                        class="overspending-shade"
                        :style="{
                            'right': `0%`,
                            'width': `${overspendingChartPercentage}%`
                        }"
                    />
                    <div v-if="totalBudgetAmt > 0" class="budget-flag" :style="{'left': `${budgetChartPercentage}%`}" />
                </div>
                <div class="project-budget-statistics">
                    <div v-if="otherPaidTotal > 0" class="item">
                        <div class="statis-title">
                            <span class="color-dot other-paid" />
                            <span>其他已支出總額<ah-tip><PaymentStatusLabel :statusNum="2" /> ＋ <PaymentStatusLabel :statusNum="3" /></ah-tip></span>
                            <span v-if="totalBudgetAmt > 0">（{{ otherPaidPercentage }}%）</span>
                        </div>
                        <div class="statis-num">
                            <div>
                                <Money :v="otherPaidTotal" />
                                <span class="cny">TWD</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="currPaymentAmt > 0" class="item">
                        <div class="statis-title">
                            <span class="color-dot curr" />
                            <span>本次請款金額</span>
                            <span v-if="totalBudgetAmt > 0">（{{ currPaymentPercentage }}%）</span>
                        </div>
                        <div class="statis-num">
                            <div>
                                <Money :v="currPaymentAmt" />
                                <span class="cny">TWD</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="otherUnpaidTotal > 0" class="item">
                        <div class="statis-title">
                            <span class="color-dot other-unpaid" />
                            <span>其他待付款總額</span>
                            <span v-if="totalBudgetAmt > 0">（{{ otherUnpaidPercentage }}%）</span>
                        </div>
                        <div class="statis-num">
                            <div>
                                <Money :v="otherUnpaidTotal" />
                                <span class="cny">TWD</span>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="statis-title">
                            <span class="color-dot budget" />
                            <span>總支出預算</span>
                            <span v-if="totalBudgetAmt > 0">（100%）</span>
                        </div>
                        <div class="statis-num">
                            <div v-if="totalBudgetAmt > 0">
                                <Money :v="totalBudgetAmt" />
                                <span class="cny">TWD</span>
                            </div>
                            <div v-if="totalBudgetAmt == 0" style="font-size: 10pt; margin-bottom: 15px">
                                未設定
                            </div>
                        </div>
                    </div>
                    <div v-if="overspendingAmt > 0" class="item">
                        <div class="statis-title">
                            <span class="color-dot overspending" />
                            <span>超支</span>
                            <span v-if="totalBudgetAmt > 0">（{{ overspendingPercentage }}%）</span>
                        </div>
                        <div class="statis-num">
                            <div>
                                <Money :v="overspendingAmt" />
                                <span class="cny">TWD</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="item">
                        <div v-if="selectedProject.payoutMax > 0">
                            <div class="statis-title">預算剩餘金額（{{ 100 - otherUsedPercentage }}%）</div>
                            <div class="statis-num">
                                <Money :v="remainCny" />
                                <span class="cny">TWD</span>
                            </div>
                        </div>
                    </div> -->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';

export default {
    components: {
        PaymentStatusLabel,
    },
    props: {
        selectedProject: {
            type: Object,
            default: () => {},
        },
        form: {
            type: Object,
            default: () => {},
        },
        source: {
            type: String,
            default: null,
        },
        isProjectBudgetVisible: Boolean,
        isProjectOpenable: Boolean,
    },
    computed: {
        // 支出總預算
        totalBudgetAmt() {
            return this.selectedProject.payoutMax;
        },
        // 本次請款金額
        currPaymentAmt() {
            return Math.round(this.form.amt * this.form.paY_CNYRAT);
        },
        // 其他已付款總額
        otherPaidTotal() {
            let sum = 0;
            // 統計該專案已付款的請款（不含此單）
            this.selectedProject.payouts?.forEach((item) => {
                if (item.sigN_STS === 2 || item.sigN_STS === 3) {
                    if (item.payoo !== this.form.payoo) {
                        sum += Math.round(item.amt * item.paY_CNYRAT);
                    }
                }
            });
            return sum;
        },
        // 其他未付款總額
        otherUnpaidTotal() {
            let sum = 0;
            // 統計該專案未付款的請款（不含此單）
            this.selectedProject.payouts?.forEach((item) => {
                if (item.sigN_STS === 1 || item.sigN_STS === 5) {
                    if (item.payoo !== this.form.payoo) {
                        sum += Math.round(item.amt * item.paY_CNYRAT);
                    }
                }
            });
            return sum;
        },
        // 其他已付款比例
        otherPaidPercentage() {
            if (this.totalBudgetAmt > 0 && this.otherPaidTotal > 0) {
                return Math.round((this.otherPaidTotal / this.totalBudgetAmt) * 100);
            }
            return 0;
        },
        // 本次請款比例
        currPaymentPercentage() {
            if (this.totalBudgetAmt > 0 && this.currPaymentAmt > 0) {
                return Math.round((this.currPaymentAmt / this.totalBudgetAmt) * 100);
            }
            return 0;
        },
        // 其未付款比例
        otherUnpaidPercentage() {
            if (this.totalBudgetAmt > 0 && this.otherUnpaidTotal > 0) {
                return Math.round((this.otherUnpaidTotal / this.totalBudgetAmt) * 100);
            }
            return 0;
        },
        // 圖表最大值
        maxChartAmt() {
            // 先計算所有請款總額
            let totalPayment = 0;
            this.selectedProject.payouts?.forEach((item) => {
                if (item.sigN_STS === 1 || item.sigN_STS === 2 || item.sigN_STS === 3 || item.sigN_STS === 5) {
                    totalPayment += Math.round(item.amt * item.paY_CNYRAT);
                }
            });
            // 和總預算比較
            if (totalPayment > this.totalBudgetAmt) {
                return totalPayment;
            }
            return this.totalBudgetAmt;
        },
        // 其他已付款"圖表"比例
        otherPaidChartPercentage() {
            if (this.totalBudgetAmt > 0 && this.otherPaidTotal > 0) {
                return Math.round((this.otherPaidTotal / this.maxChartAmt) * 100);
            }
            return 0;
        },
        // 本次請款"圖表"比例
        currPaymentChartPercentage() {
            if (this.totalBudgetAmt > 0 && this.currPaymentAmt > 0) {
                return Math.round((this.currPaymentAmt / this.maxChartAmt) * 100);
            }
            return 0;
        },
        // 其未付款"圖表"比例
        otherUnpaidChartPercentage() {
            if (this.totalBudgetAmt > 0 && this.otherUnpaidTotal > 0) {
                return Math.round((this.otherUnpaidTotal / this.maxChartAmt) * 100);
            }
            return 0;
        },
        // 總預算"圖表"比例
        budgetChartPercentage() {
            if (this.totalBudgetAmt > 0) {
                return Math.round((this.totalBudgetAmt / this.maxChartAmt) * 100);
            }
            return 0;
        },
        // 超支金額
        overspendingAmt() {
            if (this.totalBudgetAmt > 0) {
                return this.maxChartAmt - this.totalBudgetAmt;
            }
            return 0;
        },
        // 超支比例
        overspendingPercentage() {
            return Math.round((this.overspendingAmt / this.totalBudgetAmt) * 100);
        },
        // 超支"圖表"比例
        overspendingChartPercentage() {
            if (this.totalBudgetAmt > 0 && this.maxChartAmt > this.totalBudgetAmt) {
                return Math.round((1 - (this.totalBudgetAmt / this.maxChartAmt)) * 100);
            }
            return 0;
        },
        remainCny() {
            return this.totalBudgetAmt - this.payoutTotalCny;
        },
    },
    methods: {
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
    },
};
</script>

<style lang="scss" scoped>
.project-detail-view {
    background-color: #f7f7fa;
    padding: 18px 30px;
    border-radius: 8px;

    .project-name-block {
        display: flex;
        gap: 20px;
        justify-content: space-between;

        .project-type {
            background-color: #555;
            border-radius: 8px;
            color: white;
            padding: 4px 8px;
            margin-right: 10px;
            font-size: 8pt;
        }
        .project-name.clickable {
            cursor: pointer;
        }

        .project-name-actions {
            .el-button.el-button--mini {
                font-size: 8pt;
                color: #888;
                background-color: transparent;
            }
        }
    }

    .project-info-block {

        .project-budget-block {
            margin: 20px 0 10px 0;
        }
    }

    .project-budget-statistics {
        display: flex;
        justify-content: space-between;
        margin: 20px 0 0px 0;

        @media (max-width: 720px) {
            display: grid;
            grid-template-columns: 1fr 1fr;

            >.item {
                margin-bottom: 15px;
            }
        }

        >.item {
            position: relative;
            padding-left: 18px;
            line-height: 150%;

            .statis-title {
                color: #666;
                font-size: 9pt;
            }

            .statis-num {
                .money {
                    font-size: 9pt;
                }
                .cny {
                    font-size: 8pt;
                }
            }

            .color-dot {
                position: absolute;
                display: block;
                top: 7px;
                left: 0;
                width: 10px;
                height: 10px;
                border-radius: 3px;
                background-color: #EBEEF5;

                &.other-paid {
                    background-color: #463cb2;
                }
                &.curr {
                    background-color: #ffe36c;
                }
                &.other-unpaid {
                    background: repeating-linear-gradient(
                        45deg,
                        #fef5cc,
                        #fef5cc 2px,
                        #f6e8ae 2px,
                        #f6e8ae 4px
                    );
                }
                &.budget {
                    background-color: transparent;

                    &::after {
                        position: absolute;
                        bottom: 2px;
                        left: 0px;
                        content: "";
                        width: 0px;
                        height: 0px;
                        border-style: solid;
                        border-width: 0 5px 8px 5px;
                        border-color: transparent transparent #000 transparent;
                        transform: rotate(0deg);
                    }
                }
                &.overspending {
                    background: repeating-linear-gradient(
                        -45deg,
                        #ff000018,
                        #ff000018 2px,
                        #ff000038 2px,
                        #ff000038 4px
                    );
                }
            }
        }
    }

    .project-budget-usage-wrapper {
        position: relative;

        .project-budget-usage-bar {
            position: relative;
            width: 100%;
            height: 20px;
            overflow: hidden;
            background-color: #463cb20a;
            border-radius: 5px;
            // border-bottom: 1px solid #fff;

            >.other-paid-total-bar {
                position: absolute;
                top: 0;
                left: 0;
                height: 25px;
                background-color: #463cb2;
                border-right: 1px solid #fff;
                &:hover {
                    background-color: #372da7;
                }
            }
            >.current-payment-total-bar {
                position: absolute;
                top: 0;
                left: 0;
                height: 25px;
                background-color: #ffe36c;
                &:hover {
                    background-color: #fddc49;
                }
            }
            >.other-unpaid-total-bar {
                position: absolute;
                top: 0;
                left: 0;
                height: 25px;
                // background-color: #ffe36c;
                opacity: 0.75;
                background: repeating-linear-gradient(
                    45deg,
                    #fef5cc,
                    #fef5cc 4px,
                    #f6e8ae 4px,
                    #f6e8ae 8px
                );
                border-right: 1px solid #fff;
            }
        }
        >.overspending-shade {
            position: absolute;
            bottom: -7px;
            height: 7px;
            // background-color: #ff0000;
            background: repeating-linear-gradient(
                -45deg,
                #ff000038,
                #ff000038 5px,
                #ff000058 5px,
                #ff000058 8px
            );
        }
        >.budget-flag {
            position: absolute;
            top: 0;
            left: 100%;
            width: 2px;
            height: 21px;
            background-color: #000;

            &::after {
                position: absolute;
                bottom: -6px;
                left: -4px;
                content: "";
                width: 0px;
                height: 0px;
                border-style: solid;
                border-width: 0 5px 7px 5px;
                border-color: transparent transparent #000 transparent;
                transform: rotate(0deg);
            }
        }
    }
}
</style>
